export const pathAndSearchQuery = (): string => `${window.location.pathname}${window.location.search}`
